import { FCWithChildren } from "../../../../interfaces/FCWithChildren";
import { SOnboardingTourCardPointerBackground } from "./styles/SOnboardingTourCardPointerBackground";

export const OnboardingTourCardPointerWithoutClick: FCWithChildren = () => {
  return <SOnboardingTourCardPointerBackground />;
};
